module.exports = __webpack_public_path__ + "static/img/zhuban2.b0ba8e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/zhuban2.png
// module id = 8oZZ
// module chunks = 6